import AccountingAccount from "./accounting-accounts";

interface AccountingEntry {
  id?: number;
  taxPayerId?: number;
  accountId?: number;
  account?: AccountingAccount;
  accountCode?: string;
  accountName?: string;
  debitAmount?: number;
  creditAmount?: number;
  subject?: string;
  relatedId?: string;
  relatedType?: string;
  date?: string;
  status?: string;
  associatedRuc?: string;
  associatedInvoiceNumber?: string;
  associatedTaxPayer?: string;
  obs?: string;
}

export const newAccountingEntry = (): AccountingEntry => {
  return {};
};

export interface StatusData {
  class: string;
  name: string;
}

interface StatusesMap {
  [index: string]: StatusData;
}

export const ACCOUNTINGENTRYSTATUSES: StatusesMap = {
  created: {
    class: "success",
    name: "Generado",
  },
  pending: {
    class: "danger",
    name: "Pendiente",
  },
  completed: {
    class: "success",
    name: "Completado",
  },
  ignored: {
    class: "secondary",
    name: "Ignorado",
  },
  modified: {
    class: "primary",
    name: "Generado y modificado",
  },
};

export const getAccountingEntryStatusLabel = (key: string) => {
  return ACCOUNTINGENTRYSTATUSES[key].name;
};

export const getccountingEntryStatusClass = (key: string) => {
  return ACCOUNTINGENTRYSTATUSES[key].class;
};

export default AccountingEntry;
